import { Navigate, useParams, useRoutes } from "react-router-dom";

import IndexPage from "./index";
import InstanceRoutes from "./instance/routes";
import NetworkRoutes from "./network/routes";
import SiteRoutes from "./site/routes";

export default () =>
  useRoutes([
    { path: "/network/*", element: <WithParameters component={NetworkRoutes}/> },
    { path: "/site/*", element: <WithParameters component={SiteRoutes}/> },
    { path: "/instance/*", element: <WithParameters component={InstanceRoutes}/> },
    { path: "/", element: <WithParameters component={IndexPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
